import React from 'react';

import { isNil } from 'ramda';

import FormTitle from 'components/shared/Typography/FormTitle';
import Text from 'components/shared/Typography/Text';

import styles from './index.module.css';

function Contacts(props) {
  const { name, collection } = props;
  const collectionLength = collection?.length;

  return (
    <>
      <FormTitle center>{`${name}: Emergency Contacts`}</FormTitle>

      <div className={styles.list}>
        {collectionLength > 0 ? (
          collection.map((contact, i) => {
            const isPhonePresent = !isNil(contact?.phone);
            const isEmailPresent = !isNil(contact?.email);
            const isTitlePresent = !isNil(contact?.title);

            if (!isEmailPresent && !isPhonePresent) return null;

            return (
              <div key={i} className={styles.item}>
                {isTitlePresent && (
                  <Text accent isStrong className={styles.margin}>
                    {contact?.title}:
                  </Text>
                )}
                <Text accent isStrong>
                  {contact?.name}
                </Text>
                <div>
                  {isPhonePresent && <Text accent>{contact?.phone}</Text>}
                  {isPhonePresent && isEmailPresent && (
                    <Text accent className={styles.margin}>
                      ,
                    </Text>
                  )}

                  {isEmailPresent && <Text accent>{contact?.email}</Text>}
                </div>
              </div>
            );
          })
        ) : (
          <Text accent>No emergency contact info on file</Text>
        )}
      </div>
    </>
  );
}

export default Contacts;
